// Photo filenames for Holiday Party 2014
const HOLIDAY_PARTY_2014_PHOTOS = [
  'xmass-20141_15864006469_c.jpg',
  'xmass-201410_15862770350_l.jpg',
  'xmass-201412_15430393523_c.jpg',
  'xmass-201413_15430393453_c.jpg',
  'xmass-201414_15427767094_l.jpg',
  'xmass-201415_15864005509_l.jpg',
  'xmass-201416_16048096041_c.jpg',
  'xmass-201417_15864293967_c.jpg',
  'xmass-201418_15864293887_c.jpg',
  'xmass-20142_15430394163_c.jpg',
  'xmass-201420_16049353182_l.jpg',
  'xmass-201421_16049353052_c.jpg',
  'xmass-20143_16049354572_c.jpg',
  'xmass-201431_15427766214_c.jpg',
  'xmass-201437_16050042325_c.jpg',
  'xmass-201438_16024275796_c.jpg',
  'xmass-201439_16048095191_l.jpg',
  'xmass-20144_15862599448_c.jpg',
];

export default HOLIDAY_PARTY_2014_PHOTOS;
